import { useSelector } from 'react-redux';

import Text, { TextVariant } from 'src/components/atoms/Text';
import { selectors as myWorkSelectors, useSpecialtyQueueAccess } from 'src/features/myWork';
import { SpecialtyQueueRow, SpecialtyQueueValue } from '../../styles';

const SpecialtyQueueCount = (): JSX.Element | null => {
  const hasSpecialtyQueueAccess = useSpecialtyQueueAccess();
  const pendingCount = useSelector(myWorkSelectors.specialtyQueuePendingCount);

  if (!hasSpecialtyQueueAccess) {
    return null;
  }

  return (
    <SpecialtyQueueRow aria-live="polite" aria-atomic="true" data-testid="specialty-queue-count">
      <Text variant={TextVariant.normal}>Specialty Income Queue</Text>
      <SpecialtyQueueValue variant={TextVariant.normal} data-testid="specialty-queue-count-value">
        {pendingCount === null ? '—' : pendingCount}
      </SpecialtyQueueValue>
    </SpecialtyQueueRow>
  );
};

export default SpecialtyQueueCount;
